import type { WalletInstitution } from '../../interface/walet';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getWalletInstitutions = async () => {
  const { data } = await api.get<WalletInstitution[]>(
    apiConfig.routes.wallet.institutions
  );
  return data;
};

export const useGetWalletInstitutions = () => {
  return useQuery({
    queryKey: ['wallet', 'institutions'],
    queryFn: getWalletInstitutions,
    select: (data): WalletInstitutionsResponse => {
      const hasOF = data.some(
        ({ integration_type }) => integration_type === 'pluggy'
      );
      const hasEqi = data.some(
        ({ integration_type }) => integration_type === 'eqi'
      );

      const total = data.reduce((acc, { total }) => acc + total, 0);
      const investmentsTotal = data.reduce(
        (acc, { investments_total }) => acc + investments_total,
        0
      );
      const freeBalanceTotal = total - investmentsTotal;

      return {
        data,
        total,
        investmentsTotal,
        freeBalanceTotal,
        hasOF,
        hasEqi,
      };
    },
  });
};

export type WalletInstitutionsResponse = {
  data: WalletInstitution[];
  total: number;
  investmentsTotal: number;
  freeBalanceTotal: number;
  hasOF: boolean;
  hasEqi: boolean;
};
